import React from "react";
import { Anchor, ArrowRight, Ship, Waves } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const activities = [{
  id: 1,
  name: "呼吸與流動",
  description: "透過細微的呼吸引導，重新連結身體的內在節奏與平靜。",
  icon: Waves
}, {
  id: 2,
  name: "身體掃描",
  description: "有意識地感知每一寸肌膚與肌肉，釋放深層累積的壓力。",
  icon: Ship
}, {
  id: 3,
  name: "自由律動",
  description: "拋開框架，讓身體帶領心靈，在空間中自由探索與表達。",
  icon: Anchor
}];
export default function MovementSomaticAwarenessFlow() {
  return <section data-section-id="247524" id="movement-somatic-awareness-flow" className="w-full py-24 bg-background text-foreground relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-0 relative">
          
          {/* Left Column: Practices List */}
          <div className="md:col-span-5 flex flex-col justify-center space-y-6 py-8 md:py-16 md:pr-16 relative">
            {activities.map((activity, i) => {
            const Icon = activity.icon;
            return <div key={activity.id} data-index={i} className="group flex items-start gap-6 p-4 rounded-lg transition-all duration-500 hover:bg-primary/5 cursor-pointer">
                  <div className="p-4 rounded-lg border border-border bg-card text-primary group-hover:text-primary-foreground group-hover:bg-primary group-hover:shadow-md transition-all duration-500 shrink-0">
                    <Icon className="size-8 stroke-[1]" />
                  </div>
                  <div className="pt-1">
                    <h3 className="text-xl font-default font-semibold text-foreground mb-2 group-hover:text-primary transition-colors duration-300">
                      {activity.name}
                    </h3>
                    <p className="text-muted-foreground font-serif leading-relaxed">
                      {activity.description}
                    </p>
                  </div>
                </div>;
          })}

            {/* Vertical Line Decor */}
            <div className="hidden md:flex absolute right-0 top-[10%] bottom-[10%] w-px bg-border flex-col justify-end items-center">
              <div className="size-2.5 rounded-lg bg-primary translate-y-1/2 shadow-md shadow-primary/30"></div>
            </div>
          </div>

          {/* Right Column: Content & CTA */}
          <div className="md:col-span-7 flex flex-col justify-center py-8 md:py-16 md:pl-16 lg:pl-24">
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] text-foreground mb-8 tracking-tight">
              喚醒身體的智慧：<br />身心覺察與流動
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground font-serif mb-12 max-w-2xl leading-relaxed">
              身體是心靈的容器，也是通往療癒的門戶。透過身心覺察（Somatic Awareness），我們學習傾聽身體的微小訊號，在流動中找回內在的平衡與力量。這不僅是動作的練習，更是一場回歸自我的溫柔探索。
            </p>
            <div>
              <Button variant="ghost" size="lg" className="text-lg h-14 px-8 rounded-lg border-2 border-primary/20 hover:border-primary hover:bg-primary/5 text-primary font-default group" asChild>
                <Link to="/BodySensoryMovementSomaticAwarenessPage">
                  探索工作坊課程
                  <ArrowRight className="ml-3 size-5 group-hover:translate-x-1.5 transition-transform duration-300" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}